import React from 'react';
import { ConfigProvider } from 'antd';
import ReactDOM from 'react-dom/client';
// import { RouterProvider } from 'react-router-dom';
// import router from './router';
import "@/assets/style/index.scss"
import "@/assets/font/font.css"
import { Provider } from "react-redux";
import store from "./store";
import intl from "react-intl-universal";
import AppRouter from './router/useRouter';
import { UploadQueueProvider } from "@/contexts/uploadQueueContext";

const defaultLocale = localStorage.getItem("lang") || "zh-CN";
if (!localStorage.getItem("lang")) {
  localStorage.setItem("lang", defaultLocale);
}

const locales = {
  "en-US": require("./locales/en-US.json"),
  "zh-CN": require("./locales/zh-CN.json"),
};
intl.init({
  // warningHandler: (msg, detail) => {
  //   // 注意该函数开发环境有，打包后就没有了
  //   console.log(`${msg} ${detail}`);
  // },
  currentLocale: defaultLocale,
  locales,
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <ConfigProvider
  theme={{
    token: {
      // Seed Token，影响范围大
      colorPrimary: '#d62293',
      borderRadius: 2,
    },
  }}
>
  <Provider store={store}>
    <UploadQueueProvider>
      <div style={{ marginTop: "80px" }}>
        {/* <RouterProvider router={router}>
        </RouterProvider> */}
        <AppRouter />
      </div>
    </UploadQueueProvider>
  </Provider>
</ConfigProvider>
  // </React.StrictMode>
);
